import * as React from 'react';
import {
  Drawer,
  Divider,
  Typography,
  ListItemButton,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Toolbar,
} from '@mui/material';
import DevicesOtherIcon from '@mui/icons-material/DevicesOther';
import KeyIcon from '@mui/icons-material/Key';
import WebhookIcon from '@mui/icons-material/Webhook';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import { useLocation } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import ListAltIcon from '@mui/icons-material/ListAlt';
import DashboardIcon from '@mui/icons-material/Dashboard';

const drawerWidth = 250;

const SideMenu = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { pathname } = location;
  const menuItemsDevice = ['Dashboard', 'Devices', 'API Keys', 'Webhooks', 'Orders'];
  const menuItemsAccount = ['Users'];
  const pathNamesDevice = ['/', '/devices', '/apiKeys', '/webhooks', '/orders'];
  const pathNamesAccount = ['/account'];
  const iconsDevice = [
    <DashboardIcon />,
    <DevicesOtherIcon />,
    <KeyIcon />,
    <WebhookIcon />,
    <ListAltIcon />,
  ];
  const iconsAccount = [<AccountCircleIcon />];
  return (
    <Drawer
      sx={{
        width: drawerWidth,
        flexShrink: 0,
        '& .MuiDrawer-paper': {
          width: drawerWidth,
          boxSizing: 'border-box',
          zIndex: 1, // Ensure drawer is above other content if necessary
          background: '#EBF2F7', // Retaining original background
        },
      }}
      variant="permanent"
      anchor="left"
    >
      <Toolbar />
      <Divider sx={{ mt: 1 }} />
      <List>
        {menuItemsDevice.map((text, i) => (
          <ListItem key={text} disablePadding>
            <ListItemButton
              selected={pathname === pathNamesDevice[i]}
              onClick={() => navigate(pathNamesDevice[i])}
            >
              <ListItemIcon>{iconsDevice[i]}</ListItemIcon>
              <ListItemText primary={text} />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
      <Divider />
      <Typography variant="body1" sx={style.subtitle}>
        Account Management
      </Typography>
      <List>
        {menuItemsAccount.map((text, i) => (
          <ListItem key={text} disablePadding>
            <ListItemButton
              selected={pathname === pathNamesAccount[i]}
              onClick={() => navigate(pathNamesAccount[i])}
            >
              <ListItemIcon>{iconsAccount[i]}</ListItemIcon>
              <ListItemText primary={text} />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
    </Drawer>
  );
};

export default SideMenu;

const style = {
  subtitle: { textAlign: 'left', paddingLeft: 2, marginTop: 2, color: 'gray' },
};
